import React from 'react';
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useDispatch } from "react-redux";
import { useCreateDeviceView, useEditViewEnabled, useCreateCustomerView, useCustomersList, useEditViewSiteName, useEditViewSelectedDeviceId } from "../../hooks/useCloudSelectors";
import CustomerEditView from "../../components/CustomerEditView/CustomerEditView";
import DeviceEditView from "../../components/DeviceEditView/DeviceEditView";
import { changeCreateDeviceViewState } from "../../ducks/customersDuck";

const EditViewContainer = () => {
    const createDeviceVisible = useCreateDeviceView();
    const editViewVisible = useEditViewEnabled();
    const createCustomerVisible = useCreateCustomerView();
    const customers = useCustomersList();
    const selectedSiteName = useEditViewSiteName();
    const selectedDeviceId = useEditViewSelectedDeviceId();
    const selectedCustomer = customers.find(c => c.customerName === selectedSiteName);
    const dispatch = useDispatch();

    const emptyCustomerObject = {
        customerId: '',
        customerName: '',
        siteId: '',
        siteName: '',
        city: '',
        address: '',
        gpsLat: '',
        gpsLong: '',
        createCompanyView: true,
    };

    const emptyDeviceObject = {
        deviceId: '',
        deviceName: '',
        edgeUnitId: '',
        edgeUnitaName: '',
        config: '',
        solutionType: '',
        createDeviceView: true,
    };

    // Nothing selected
    if (!editViewVisible && !createCustomerVisible) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", opacity: 0.5 }}>
                <Typography variant="h6">Select a site from the list to edit</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ maxWidth: 800, mx: "auto", width: "100%" }}>
            {/* Create new site form */}
            {createCustomerVisible && (
                <CustomerEditView customer={emptyCustomerObject} createCustomerVisible={createCustomerVisible} />
            )}

            {/* Edit existing site */}
            {editViewVisible && selectedCustomer && (
                <Stack spacing={3}>
                    <CustomerEditView customer={selectedCustomer} createCustomerVisible={false} />

                    <Divider />

                    <Typography variant="h6">Systems</Typography>

                    {selectedCustomer.devices.map(device => (
                        <DeviceEditView device={device} key={device.deviceId} highlighted={device.deviceId === selectedDeviceId} />
                    ))}

                    {createDeviceVisible && <DeviceEditView device={emptyDeviceObject} />}

                    <Button
                        variant="outlined"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() => { if (!createDeviceVisible) dispatch(changeCreateDeviceViewState()); }}
                        sx={{ alignSelf: "flex-start" }}
                    >
                        Add System
                    </Button>
                </Stack>
            )}
        </Box>
    );
};

export default EditViewContainer;
